import React, { useState } from "react";
import "./header.scss";
import { CodeSandboxCircleFilled, MenuOutlined } from "@ant-design/icons";
import { Link, useLocation } from "react-router-dom";
import { Col, Row, Menu, Image, Space, Drawer } from "antd";
import Logo from "../../../assets/images/header/nucleusteq_logo.svg";
import whitearrow from "../../../assets/images/header/white_arrow.svg";
import FunctionTitles from "../../Utiles/FunctionTitles";
const { SubMenu } = Menu;

const Header = () => {
  const currentRoute = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [activePage, setActivePage] = useState<string | null>(null);
  const [activePageData, setActivePageData] = useState<any[]>([]);

  const menuData = [
    {
      title: "Products",
      items: [
        { name: "FYNDR", url: "https://fyndr.us/", isProduct: true },
        { name: "NUODATA", url: "https://nuodata.io/", isProduct: true },
        {
          name: "NUODATA-DATA MODERNIZATION CLOUD",
          url: "https://nuodata.io/how-it-works/",
          isProduct: true,
        },
        {
          name: "NUODATA-DATA MANAGEMENT CLOUD",
          url: "https://nuodata.io/data-management/",
          isProduct: true,
        },
        { name: "DATA GOVERNANCE", url: "data-governance/" },
      ],
    },
    {
      title: "Industries",
      items: [
        { name: "BANKING & FINANCIAL", url: "bank/" },
        { name: "RETAIL, CONSUMER GOODS & SERVICES", url: "retail/" },
        { name: "INSURANCE", url: "insurance/" },
        { name: "LIFE SCIENCES & HEALTHCARE", url: "life/" },
        { name: "COMMUNICATION, MEDIA AND TECHNOLOGY", url: "communication/" },
        { name: "ENERGY & UTILITIES", url: "energy/" },
        { name: "TRAVEL AND HOSPITALITY", url: "travel/" },
      ],
    },
    {
      title: "Services",
      items: [
        { name: "ENTERPRISE DATA MODERNIZATION", url: "edm/" },
        { name: "ENTERPRISE DATA ADVISORY & ENGINEERING", url: "bigdata/" },
        { name: "AI , ML & ANALYTICS", url: "analytics/" },
        { name: "CLOUD SERVICES", url: "cloud/" },
        { name: "ENTERPRISE AUTOMATION", url: "auto/" },
        { name: "CRM AND ERP", url: "ui/" },
      ],
    },
    {
      title: "Overview",
      items: [
        { name: "ABOUT US", url: "aboutUs/" },
        { name: "LEADERSHIP", url: "leadership/" },
        { name: "PARTNERS", url: "partners/" },
        { name: "CUSTOMERS", url: "customers/" },
        { name: "SUCCESS STORIES", url: "successStories1/" },
      ],
    },
    // {
    //   title: "Insight",
    //   items: [
    //     { name: "THOUGHT LEADERSHIP", url: "thought-leadership/" },
    //     { name: "BLOG", url: "blog/" },
    //     { name: "NEWS", url: "news/" },
    //   ],
    // },

    {
      title: "Careers",
      items: [
        {
          name: "CAREER PORTAL",
          url: "https://nucleusteq.breezy.hr/",
          isProduct: true,
        },
        { name: "CAREER AT NUCLEUSTEQ", url: "careerPage/" },
      ],
    },
  ];

  FunctionTitles("NucleusTeq | Home");

  const handleSubMenuClick = (title: string, items: any[]) => {
    setActivePage(title);
    setActivePageData(items);
    setIsOpen(true);
  };

  const renderSubMenu = (title: string, items: any[]) => (
    <SubMenu
      onTitleClick={() => {
        handleSubMenuClick(title, items);
      }}
      title={
        title === "Products" ? (
          <div
            style={{ display: "flex", alignItems: "center" }}
            onMouseEnter={() => {
              handleSubMenuClick(title, items);
            }}
          >
            <CodeSandboxCircleFilled
              className="anim"
              style={{
                backgroundColor: "#F0592A",
                borderRadius: "100%",
                fontSize: "1vw",
                color: "#F0592A",
              }}
            />{" "}
            Products
          </div>
        ) : (
          <div
            style={{ display: "flex", alignItems: "center" }}
            onMouseEnter={() => {
              handleSubMenuClick(title, items);
            }}
          >
            {title}
          </div>
        )
      }
      className={`subMenuItem ${
        activePage === title ? "subMenuItemActive" : ""
      }`}
      style={{
        height: "9vh",
        display: "flex",
        alignItems: "center",
      }}
    />
  );

  const renderMenuItems = (items: any[], isQuickLinks = false) =>
    items.map((menuItem, index) => (
      <Row key={index} onClick={() => menuChange(menuItem)}>
        <Space size={"small"} direction="horizontal">
          <img
            src={whitearrow}
            alt="whitearrow"
            style={{ alignSelf: "center" }}
          />
          <Col
            className={`header_menu-item ${isQuickLinks ? "quickLinks" : ""}`}
          >
            <Link
              to={menuItem.url}
              target={menuItem.isProduct ? "_blank" : "_self"}
              className="menu-text-decoration"
            >
              {menuItem.name}
            </Link>
          </Col>
        </Space>
      </Row>
    ));

  const menuChange = (value: any) => {
    if (value.isReady) {
    } else {
      const url = value.url.startsWith("http") ? value.url : `/${value.url}`;
      if (value.isProduct) {
        window.open(url, "_blank");
      } else {
        window.location.href = url;
      }
    }
  };

  return (
    <>
      <Drawer
        title="Basic Drawer"
        placement={"top"}
        closable={true}
        onClose={() => setIsOpen(false)}
        open={isOpen}
        key={"placement"}
        style={{ marginTop: "10vh", backgroundColor: "rgb(255,255,255, .5)" }}
        headerStyle={{ display: "none" }}
        height={"90vh"}
      >
        <div className="subMenuP" onClick={() => setIsOpen(false)}>
          <div className="subMenuPC">
            <div>
              <Row>
                <Col>
                  <Row className="header_menu-links">
                    {activePage === "Products"
                      ? "Products Links"
                      : activePage === "Industries"
                      ? "Industries Links"
                      : activePage === "Services"
                      ? "Services Links"
                      : activePage === "Overview"
                      ? "Overview Links"
                      : activePage === "Insight"
                      ? "Insight Links"
                      : activePage === "Careers"
                      ? "Careers Links"
                      : ""}
                  </Row>
                  {renderMenuItems(activePageData)}
                </Col>
                <Col>
                  {activePage &&
                  activePage !== "Overview" &&
                  [
                    "Products",
                    "Industries",
                    "Services",
                    "Overview",
                    "Insight",
                    "Careers",
                    "Contact Us",
                  ].includes(activePage) ? (
                    <Col style={{ paddingLeft: "5rem" }}>
                      <Row className="header_menu-links quickLinks">
                        Quick links
                      </Row>
                      {renderMenuItems(
                        menuData.find((menu) => menu.title === "Overview")
                          ?.items || [],
                        true
                      )}
                    </Col>
                  ) : null}
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </Drawer>

      <div
        className="menuDiv"
        style={{ position: "sticky", top: 0, width: "100%", zIndex: "1002" }}
      >
        <Row className="infoRow">
          <Col xs={14} sm={7} md={7} lg={7} xl={6} xxl={7}>
            <div className="infoColImage">
              <Link to="/">
                <Image
                  preview={false}
                  src={Logo}
                  loading="lazy"
                  onClick={FunctionTitles("NucleusTeq | Home")}
                  className="headerLogo"
                />
              </Link>
            </div>
          </Col>
          <Col xs={0} sm={0} md={16} lg={17} xl={18} xxl={17}>
            <Menu
              mode="horizontal"
              overflowedIndicator={<MenuOutlined className="headerMenu" />}
              style={{
                marginLeft: "8vw",
                justifyContent: "end",
                display: "flex",
                zIndex: "2000",
              }}
              className="menuColStyle"
            >
              {menuData.map((menuItem, index) =>
                renderSubMenu(menuItem.title, menuItem.items)
              )}
              <SubMenu
                onTitleClick={() => setActivePage("Contact Us")}
                onTitleMouseEnter={() => setIsOpen(false)}
                key="dropdown7"
                title={
                  <Link
                    to="/contact"
                    style={{ textDecoration: "none", color: "#fff" }}
                  >
                    Contact Us
                  </Link>
                }
                className={`subMenuItem ${
                  activePage === "Contact Us" ? "subMenuItemActive" : ""
                }`}
                style={{
                  height: "9vh",
                  display: "flex",
                  alignItems: "center",
                }}
              />
            </Menu>
          </Col>
          <Col
            className="infoColManu"
            xs={8}
            sm={10}
            md={0}
            lg={0}
            xl={0}
            xxl={0}
          >
            <Menu
              style={{ display: "flex", justifyContent: "flex-end" }}
              mode="horizontal"
              overflowedIndicator={<MenuOutlined className="headerMenu" />}
            >
              {menuData.map((menuItem, index) => (
                <SubMenu
                  key={`dropdown${index + 1}`}
                  title={menuItem.title}
                  onTitleClick={() => setActivePage(menuItem.title)}
                  className={`subMenuItem ${
                    activePage === menuItem.title ? "subMenuItemActive" : ""
                  }`}
                >
                  <div
                    style={{
                      width: "100vw",
                      padding: "24px",
                      background: "#020C2E",
                    }}
                  >
                    <Row className="header_menu-links">
                      {menuItem.title} Links
                    </Row>
                    {renderMenuItems(menuItem.items)}
                    {menuItem.title === "Products" ||
                    menuItem.title === "Industries" ||
                    menuItem.title === "Services" ||
                    menuItem.title === "Overview" ||
                    menuItem.title === "Insight" ||
                    menuItem.title === "Careers" ||
                    menuItem.title === "Contact Us" ? (
                      <Col>
                        <Row className="header_menu-links quickLinks">
                          Quick links
                        </Row>
                        {renderMenuItems(
                          menuData.find((menu) => menu.title === "Overview")
                            ?.items || []
                        )}
                      </Col>
                    ) : null}
                  </div>
                </SubMenu>
              ))}
              <SubMenu
                key="dropdown7"
                title={
                  <Link
                    to="/contact"
                    style={{ textDecoration: "none", color: "#fff" }}
                  >
                    Contact Us
                  </Link>
                }
                onTitleClick={() => setActivePage("Contact Us")}
                onTitleMouseEnter={() => setIsOpen(false)}
                className={`subMenuItem ${
                  activePage === "Contact Us" ? "subMenuItemActive" : ""
                }`}
              ></SubMenu>
            </Menu>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Header;
